import { render } from "./tagline.vue?vue&type=template&id=475c06bb"
import script from "./tagline.vue?vue&type=script&lang=js"
export * from "./tagline.vue?vue&type=script&lang=js"

import "./tagline.vue?vue&type=style&index=0&id=475c06bb&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__